export enum NAV_TYPES {
    STUDIO = 1,
    FRANCHISE,
    DIVISION
}

export enum NAVIGATE_ASSETS {
    PREVIOUS_ASSET = 'PREV',
    NEXT_ASSET = 'NEXT'
}